<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="employee_type_list" sort-by="calories" dense class="elevation-1 mytable"
      :search="search">
      <template v-slot:top>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Employee Type Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense justify="center">
          <v-col sm="3" md="3" cols="12">
          </v-col>
          <v-col sm="6" md="6" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
          <v-col sm="3" md="3" cols="12">

            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small class="mb-2 button" v-on="on">Add Employee Type</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="10" md="8">
                        <v-text-field v-model="editedItem.employee_type" persistent-hint :disabled="editedIndex != -1"
                          :hint="editedIndex==-1?'For example :: Director, Dean, HOD, Teacher':'noneditable'"
                          :filled="editedIndex==-1?false:true" label="Employee Type"
                          :error="errorMsg.employeeType?true:false"
                          :error-messages="errorMsg.employeeType?'Required':''">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">
              edit
            </v-icon>
          </v-avatar>
        </div>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      errorMsg:{
        employeeType:false
      },
      search:'',
    snackbar_msg: "",
    color: "",
      snackbar: false,
      // extraBreadcrumbItems: [
      

      // ],
      // breadcrumbClass: "breadcrumb-style1",

      dialog: false,
      headers: [
        {
          text: 'Employee Type',align: 'left',sortable: true,value: 'employee_type',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      employee_type_list: [],
      editedIndex: -1,
      editedItem: {
        employee_type: '',
        isactive:true
      },
      defaultItem: {
        employee_type: '',
        isactive:true
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Employee Type' : 'Edit Employee Type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    mounted(){
      axios
      .post("/roleManagement/employeeType")
      .then(res => {
        if (res.data.msg == "200") {
          this.employee_type_list = res.data.employee_type_list
          this.load = true;
        } else {
        }
      })
      .catch(error => {
        window.console.log(error);
      });
    },
    methods: {
       initializeErrorMsgFalse(){
      this.errorMsg.employeeType=false;
     
    },
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
      editItem (item) {
        this.editedIndex = this.employee_type_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.employee_type_list.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.employee_type_list.splice(index, 1)
      },

      close () {
        this.initializeErrorMsgFalse();
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          if(this.isValidated()) {
          axios
          .post("/roleManagement/editEmployeeType", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              Object.assign(this.employee_type_list[this.editedIndex], this.editedItem)
              this.showSnackbar(
                  "#4caf50",
                  "Employee Type Updated Successfully..."
                ); // show snackbar on succes
            }
          })
          .catch(error => {
            window.console.log(error);
          });
           this.close()
          }
        } else {
          if(this.isValidated()) {
          axios
          .post("/roleManagement/saveEmployeeType", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
              this.employee_type_list.push(this.editedItem)
               this.showSnackbar(
                  "#4caf50",
                  "Employee Type Added Successfully..."
                ); // show snackbar on succes
            }
            else if(res.data.status.code == "NA"){
                this.showSnackbar("#b71c1c", "Employee Type Already Present!!!"); // show snackbar on error  
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
          }
        }
        
      }, // end of save()

      isValidated(){
      // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
      if(this.editedItem.employee_type)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.employee_type)
            {
              this.errorMsg.employeeType=true
            }
           
        return false;
      }  
     } // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>